import type { IconProps } from './types';
import './icons.css';

export default function ChangeLogDeleted({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-change-log-deleted ${className || ''}`}
    >
      <path
        fill="#D90034"
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm2.333 9a1 1 0 1 0 0-2H5.667a1 1 0 1 0 0 2h4.666Z"
      />
    </svg>
  );
}
